/**
 * Change Password View
 */

define(function(require, exports, module) {
    'use strict';

    const core = require('core');
    const user = require('user');
    const _ = require('underscore');
    const Form = require('class/form.class');
    const { dispatcher } = require('bundle');
    const serverUtil = require('util/server.util');
    const BaseReplacerView = require('common/base.replacer.view');
    const userValidationConfig = require('modules/user/user.validation.config');

    module.exports = BaseReplacerView.extend({

        events: _.extend({}, BaseReplacerView.prototype.events, {
            'submit form': 'changePasswordAction'
        }),

        initialize: function(options) {
            this.params = options?.params || [];
        },

        render: function() {
            this.$el.html(this.tmpl('change-password', {
                showOldPassword: user.isLoggedIn() || this.params.includes('showOldPassword')
            }));

            this.form = new Form(this.$('.fn-changepassword-form'), {
                validationConfig: userValidationConfig()
            });

            return this;
        },

        changePasswordAction: function(e) {
            e.preventDefault();

            return this.form.validate().done(function(data, form) {
                form.showLoading();

                user.changePassword(data)
                    .always(this.form.hideLoading.bind(this.form))
                    .done(this.successRequest.bind(this))
                    .fail(this.errorRequest.bind(this));
            }.bind(this));
        },

        /**
         * Needed for request pin code within Two Factor Auth popup
         */
        resendTwoFactorAuthPin: function() {
            const data = this.form._getAllData();

            return user.changePassword(data);
        },

        onTwoFactorAuthSuccess: function() {
            const data = this.form._getAllData();

            this.form.showLoading();

            user.changePassword(data)
                .always(this.form.hideLoading.bind(this.form))
                .done(this.successRequest.bind(this))
                .fail(this.errorRequest.bind(this));
        },

        showTwoFactorAuthPopup: function(response) {
            core.trigger('app:message', {
                ID: 'twoFactorAuthentication',
                data: {
                    onCancel: () => {
                        dispatcher.dispatch('2fa-popup-closed', 'change-password');
                    },
                    onSuccess: this.onTwoFactorAuthSuccess.bind(this),
                    resendHandler: this.resendTwoFactorAuthPin.bind(this),
                    title: serverUtil.getMessageFromActions(response)
                }
            });
        },

        successRequest: function(response) {
            if (this.isTwoFactorAuthError(response)) {
                this.showTwoFactorAuthPopup(response);

                return;
            }

            core.trigger('user:password-changed', {
                password: this.form.data('password')
            });

            this.showInfo({
                content: this.translate('playtech.mobile.system.changePass.successMessage')
            });
        },

        errorRequest: function(error) {
            if (this.isTwoFactorAuthError(error)) {
                this.showTwoFactorAuthPopup(error);

                return;
            }

            const prefix = 'playtech.mobile.system.changePass.error.';
            const content = serverUtil.getErrorMessage(error, { prefix });

            this.form.showErrorMessage({ content });
        },

        isTwoFactorAuthError: function(error) {
            var response = error.response || error;

            if (response?.data?.errorCode === 303) {
                return true;
            } else if (response?.data?.sessionValidationData?.SessionValidationBy2FAData) {
                return true;
            }

            return false;
        }
    }, {
        nameOfReplacers: [
            'CHANGE_PASSWORD'
        ]
    });
});
